import hours from "../imgs/hours.png";

function Iframe(props) {
  return <div dangerouslySetInnerHTML={{ __html: props.iframe ? props.iframe : "" }} />;
}

function HoursPage() {
  return (
    <div className="hours-page">
      <div className="hours">
        <img className="hours-img" src={hours}></img>
      </div>
      <div className="hours-desc">
        <p>
          <a href="https://calendar.google.com/calendar/embed?src=c_bf4a28e8bd6356338aac0b151a2ab7c48b5a53b8d65720560b021681a32dce42%40group.calendar.google.com&ctz=America%2FNew_York" target="_blank"> Office hours calendar.</a> Individual TA Hours will be available for remote students. Group TA Hours will be in-person only.{" "}
          <b>
            All students must queue up for TA hours on{" "}
            <a href="https://hours.cs.brown.edu/" target="_blank">
              Hours
            </a>
            .
          </b>
        </p>
      </div>
      <div className="calendar-wrapper">
        <Iframe iframe='<iframe src="https://calendar.google.com/calendar/embed?src=c_bf4a28e8bd6356338aac0b151a2ab7c48b5a53b8d65720560b021681a32dce42%40group.calendar.google.com&ctz=America%2FNew_York" align="center" style="border: 0" width="90%" height="600" frameborder="0" scrolling="no"></iframe>' />
      </div>
    </div>
  );
}

export default HoursPage;
